import { render, staticRenderFns } from "./ModalConfirmApproval.vue?vue&type=template&id=624dde02&"
import script from "./ModalConfirmApproval.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports